import { Component, Inject, PropSync, Vue } from 'vue-property-decorator'
import {
    InvoiceReceiptStatus,
    InvoiceReceiptResponse
} from '@/api/services/billing/invoice-receipt/billing-invoice-receipt.dto'
import { PaymentMethodResponse } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { billingCommonPaymentMethodService } from '@/api/services/billing/common-payment-method/billing-common-payment-method.service'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { Validator } from 'vee-validate'
import {
    BillingModalInvoiceReceiptFormState,
    initialBillingModalInvoiceReceiptFormState
} from '@/modules/billing-module/components/modal/invoice-receipt/components/form/billing-modal-invoice-receipt-form.model'

@Component
export default class BillingModalInvoiceReceiptForm extends Vue {
    @PropSync('invoiceReceipt', { type: Object, required: true }) syncedInvoiceReceipt!: InvoiceReceiptResponse

    @Inject() externalValidator!: Validator

    state: BillingModalInvoiceReceiptFormState
    constructor() {
        super()
        this.state = initialBillingModalInvoiceReceiptFormState()
        this.$validator = this.externalValidator
    }

    get visibleRealTotalValueInput(): boolean {
        return this.invoiceReceiptVerified || this.invoiceReceiptGenerated
    }

    get disabledVisibleRealTotalValueInput(): boolean {
        return this.invoiceReceiptVerified
    }

    get invoiceReceiptGenerated(): boolean {
        return this.syncedInvoiceReceipt.status.code === InvoiceReceiptStatus.GENERATED
    }
    get invoiceReceiptVerified(): boolean {
        return this.syncedInvoiceReceipt.status.code === InvoiceReceiptStatus.VERIFIED
    }

    get isFieldRequired(): boolean {
        return !!this.syncedInvoiceReceipt.realTotalValue
    }

    async getAllActivePaymentMethods(): Promise<PaymentMethodResponse[]> {
        const response =
            await PromiseUtils.toCallSecure(
                billingCommonPaymentMethodService.getAllActivePaymentMethods())
        return response ?? []
    }

    increaseRealTotalValueKey(): void {
        this.state.realTotalValueKey++
    }
}
